function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.25,
  cy: 1.25,
  r: 1.25
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.25,
  cy: 1.25,
  r: 1.25
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.25,
  cy: 1.25,
  r: 1.25
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.25,
  cy: 6.25,
  r: 1.25
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.25,
  cy: 6.25,
  r: 1.25
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.25,
  cy: 6.25,
  r: 1.25
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.25,
  cy: 11.25,
  r: 1.25
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.25,
  cy: 11.25,
  r: 1.25
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.25,
  cy: 11.25,
  r: 1.25
});

function SvgGridViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "#908E8E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewIcon);
export default __webpack_public_path__ + "static/media/grid-view-icon.dee2701d.svg";
export { ForwardRef as ReactComponent };